module.exports = __webpack_public_path__ + "adca41f546297f2f7392f34c649f7270.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/ice-cream-s.png
// module id = 2050
// module chunks = 0